import { PropsWithChildren } from 'react'
import styles from './loaderWrapper.module.scss'
import LoaderSVG from './LoaderSVG'

interface ILoaderOverlayWrapper {
  isLoading: boolean
  overlayClasses?: string
}

export const LoaderOverlayWrapper: React.FC<PropsWithChildren<ILoaderOverlayWrapper>> = ({
  overlayClasses = '',
  isLoading,
  children,
}) => {
  const wrapperClasses = overlayClasses ? overlayClasses : styles.loaderOverlay

  return (
    <div className={isLoading ? wrapperClasses : ''}>
      <LoaderSVG className={isLoading ? styles.centerAligned : 'd-none'}></LoaderSVG>
      {children}
    </div>
  )
}
